<template>
  <v-container fluid id="workflow-page-create">
    <!-- <v-row class="ma-3">
        <v-col cols="12">Chargement des informations du message personnel</v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12" class="colored-card-border pa-12">
        <v-row>
          <v-col cols="12" class="blank-card">
            
            <v-row v-if="step === 3">
              <v-col
                cols="12"
                xl="10"
                offset-xl="1"
                sm="10"
                offset-sm="1"
                class="text-center mt-12"
              >
                <div class="text size-xxlarge weight-bold color-purple-base">
                  Félicitations
                </div>
                <div class="text size-large ma-12 pb-8">
                  Votre message est enregistré !
                </div>
                <div class="mb-6">
                  <v-btn
                    class="
                      theme-btn
                      shape-rounded
                      filled-purple
                      glow
                      drawer-button
                    "
                    @click="setStep(1)"
                    >Retour à l'édition des messages</v-btn
                  >
                </div>
              </v-col>
            </v-row>
            <v-row v-if="step != 3">
              <v-col
                cols="12"
                class="
                  text-center
                  font-alt
                  text
                  weight-bold
                  size-medium
                  color-orange-dark
                  my-6
                "
              >
                Personnalisez vos messages envoyés lors de l’inscription<br />
                et la désinscription de vos clients
              </v-col>
              <v-col cols="12" class="">
                <v-row class="pa-3">
                  <v-col
                    cols="12"
                    xl="8"
                    offset-xl="2"
                    lg="10"
                    offset-lg="1"
                    sm="12"
                    class="scenario-builder-card mb-12"
                  >
                    <div class="top-icon">
                      <v-img src="@/assets/images/start.png" />
                    </div>
                    <v-row>
                      <v-col cols="12" class="text-center mt-12">
                        <div
                          class="
                            step-title
                            current
                            text
                            font-alt
                            weight-bold
                            size-xsmall
                          "
                          @click="setStep(1)"
                        >
                          1. Votre message de bienvenue
                        </div>
                        <v-col cols="12" class="text-center">
                          <div
                            class="visual-red-wire"
                            style="height: 50px"
                          ></div>
                        </v-col>
                        <div
                          v-if="step === 2"
                          class="
                            step-title
                            current
                            text
                            font-alt
                            weight-bold
                            size-xsmall
                          "
                        >
                          2. Votre message de désinscription
                        </div>
                      </v-col>
                      <v-col cols="12" class="text-center" v-if="step === 2">
                        <div class="visual-red-wire" style="height: 50px"></div>
                      </v-col>
                    </v-row>
                    <v-row v-if="personalMessageLoaded">
                      <v-col cols="12">
                        <v-card class="pb-4 mx-16">
                          <v-row>
                            <v-col cols="12">
                              <h4 class="pb-0 pl-4">
                                Votre message version mail
                              </h4></v-col
                            >
                          </v-row>
                          <v-form ref="form" v-model="valid" v-if="step === 1">
                            <TextEditorTipTap
                              class="mb-4"
                              :rules="textFieldRules"
                              :value="personalMessageData.optin.email_content"
                              @input="
                                (v) =>
                                  updatePersonalMessageData(
                                    'optin',
                                    'email_content',
                                    v
                                  )
                              "
                              @input-raw="
                                (v) =>
                                  updatePersonalMessageData(
                                    'optin',
                                    'email_content_raw',
                                    v
                                  )
                              "
                            />
                          </v-form>
                          <v-form ref="form" v-model="valid" v-if="step === 2">
                            <TextEditorTipTap
                              class="mb-4"
                              :rules="textFieldRules"
                              :value="personalMessageData.optout.email_content"
                              @input="
                                (v) =>
                                  updatePersonalMessageData(
                                    'optout',
                                    'email_content',
                                    v
                                  )
                              "
                              @input-raw="
                                (v) =>
                                  updatePersonalMessageData(
                                    'optout',
                                    'email_content_raw',
                                    v
                                  )
                              "
                            />
                          </v-form>
                          <v-row class="mx-1 mb-4">
                            <v-col cols="6" align="start" class="pb-0">
                              <h4 class="pb-0">Votre message version sms</h4>
                            </v-col>
                            <!-- <v-col cols="6" align="end" class="pb-0">
                              <div
                                class="counter"
                                v-show="hasCharactersRemaining"
                              >
                                {{ totalCharacters }}/{{maxLength}} caractères.
                              </div>
                              <div
                                :class="{
                                  'max-counter': !hasCharactersRemaining,
                                }"
                                v-show="!hasCharactersRemaining"
                              >
                                Limite de caractères atteinte.
                              </div>
                            </v-col> -->
                            <v-col cols="12">
                              <v-form
                                ref="form"
                                v-model="valid"
                                v-if="step === 1"
                              >
                                <v-textarea
                                  :value="personalMessageData.optin.sms_content"
                                  @input="
                                    (v) =>
                                      updatePersonalMessageData(
                                        'optin',
                                        'sms_content',
                                        v
                                      )
                                  "
                                  :maxLength="maxLength"
                                  :rules="textFieldRules"
                                  outlined
                                  placeholder="Mon message..."
                                  no-resize
                                  hide-details=""
                                >
                                </v-textarea>
                              </v-form>
                              <v-form
                                ref="form"
                                v-model="valid"
                                v-if="step === 2"
                              >
                                <v-textarea
                                  :value="
                                    personalMessageData.optout.sms_content
                                  "
                                  @input="
                                    (v) =>
                                      updatePersonalMessageData(
                                        'optout',
                                        'sms_content',
                                        v
                                      )
                                  "
                                  :maxLength="maxLength"
                                  :rules="textFieldRules"
                                  outlined
                                  placeholder="Mon message..."
                                  no-resize
                                  hide-details=""
                                >
                                </v-textarea>
                              </v-form>
                            </v-col>
                            <v-row class="pt-4">
                              <v-col cols="12"><v-divider /></v-col>
                              <v-col align="center">
                                <v-dialog
                                  class="theme-dialog"
                                  v-model="dialog"
                                  transition="dialog-bottom-transition"
                                  width="800px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      elevation="0"
                                      rounded
                                      outlined
                                      style="color: #6f52eb"
                                      class="
                                        theme-btn
                                        drawer-button
                                        shape-rounded
                                      "
                                      ><strong>Aperçu de mon email</strong>
                                    </v-btn>
                                  </template>

                                  <EmailPreview
                                    :personal_message="personalMessageData"
                                  />
                                </v-dialog>
                              </v-col>
                              <v-col align="center">
                                <v-btn
                                  @click="savePersonalMessageData(2)"
                                  :disabled="!valid"
                                  class="
                                    theme-btn
                                    shape-rounded
                                    filled-purple
                                    drawer-button
                                  "
                                  >Enregistrer mon message</v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-card>
                        <v-col cols="12" class="text-center">
                          <v-col cols="12" class="text-center">
                            <div
                              v-if="step === 1"
                              class="visual-red-wire"
                              style="height: 50px"
                            ></div>
                          </v-col>
                          <div
                            @click="setStep(2)"
                            v-if="step === 1"
                            class="
                              step-title
                              current
                              text
                              font-alt
                              weight-bold
                              size-xsmall
                            "
                          >
                            2. Votre message de désinscription
                          </div>
                        </v-col>
                      </v-col>
                      <v-row> </v-row>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TextEditorTipTap from "./components/textarea-editor-tiptap.vue";
import EmailPreview from "./components/v-card-email-preview.vue";

export default {
  components: {
    TextEditorTipTap,
    EmailPreview,
  },
  data: () => {
    return {
      personal_message: {},
      maxLength: 150,
      dialog: false,
      preview: null,
      showEmailPreview: false,
      fileInput: null,
      image: null,
      step: 1,
      textFieldRules: [(v) => !!v || "Merci de compléter les champs"],
      valid: true,
      //   rules: [
      //     (value) =>
      //       !value || value.size < 2000000 || "Le logo doit faire moins de 2 MB!",
      //   ],
    };
  },
  created() {
    this.loadPersonalMessageData();
  },
  methods: {
    previewImage(file) {
      if (file) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = file;
        reader.readAsDataURL(file);
      }
    },

    pickType(type) {
      this.type = type;
    },

    loadPersonalMessageData() {
      this.$store.dispatch("personalMessage/loadPersonalMessageData", {
        parameters: {
          establishment_id: this.$store.state.auth.users.data.establishment_id,
        },
      });
    },

    updatePersonalMessageData(type, field, value) {
      this.$store.commit("personalMessage/setPersonalMessageDataField", {
        type: type,
        field: field,
        value: value,
      });
    },

    setStep(step) {
      if (step === 1) {
        this.step = 1;
      } else if (step === 2) {
        this.step = 2;
      } else if (step === 3) {
        this.step = 3;
      }
    },

    savePersonalMessageData() {
      const isEmpty = this.personalMessageData.optin.email_content.length;
      if (isEmpty === 0 || isEmpty === undefined) {
        this.$store.commit(
          "ui/triggerAlert",
          { type: "error", msg: "Merci de ne pas laisser de champs vides" },
          { root: true }
        );
      } else {
        this.$refs.form.validate();
        if (this.step === 1) {
          this.step = 2;
        } else if (this.step === 2) {
          this.$store.dispatch("personalMessage/upsertPersonalMessageData", {
            success: () => {
              this.step = 3;
            },

            parameters: {
              optin: {
                id: this.$store.state.personalMessage.personal_message.data
                  .optin.id,
                sms_content:
                  this.$store.state.personalMessage.personal_message.data.optin
                    .sms_content,
                email_content:
                  this.$store.state.personalMessage.personal_message.data.optin
                    .email_content,
              },
              optout: {
                id: this.$store.state.personalMessage.personal_message.data
                  .optout.id,
                sms_content:
                  this.$store.state.personalMessage.personal_message.data.optout
                    .sms_content,
                email_content:
                  this.$store.state.personalMessage.personal_message.data.optout
                    .email_content,
              },

              establishment_id:
                this.$store.state.auth.users.data.establishment_id,
            },
          });
        }
      }
    },
  },

  computed: {
    // totalCharacters() {
    //     return this.$store.state.personalMessage.personal_message.data.optin.sms_content.length
    // },

    // hasCharactersRemaining() {
    //     return this.totalCharacters < this.maxLength
    // },

    /*
     ** PERSONAL FROM STORE
     */

    personalMessageLoading() {
      return this.$store.state.personalMessage.personal_message.loading;
    },
    personalMessageLoaded() {
      return this.$store.state.personalMessage.personal_message.loaded;
    },
    personalMessageData() {
      return this.$store.state.personalMessage.personal_message.data;
    },
  },
};
</script>

<style lang="scss">
#workflow-page-create {
  .colored-card-border {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    background-color: #6f52eb;
    position: relative;
    overflow: hidden;

    .visual-red-wire {
      display: inline-block;
      width: 5px;
      background-color: #ff7461;
    }

    .blank-card {
      border-radius: 7.5px;
      background-color: #fff;

      .scenario-builder-card {
        border-radius: 50px;
        background-color: #f0f0f0;
        position: relative;
        padding-bottom: 80px;

        .top-icon {
          position: absolute;
          top: -30px;
          right: calc(50% - 30px);
          border: 10px solid white;
          border-radius: 50%;
        }

        .bottom-icon {
          position: absolute;
          bottom: -30px;
          right: calc(50% - 30px);
          border: 10px solid white;
          border-radius: 50%;
        }

        .step-title {
          display: inline-block;
          color: white;
          padding: 10px 40px;
          border-radius: 25px;

          &:not(.current) {
            background: #ffc306;
          }

          &.current {
            background-color: $color-secondary;
          }

          &.active {
            background-color: $color-secondary;
            cursor: pointer;
          }
        }

        .scenario-pick-type {
          display: inline-block;
          cursor: pointer;
          padding: 14px 28.5px 14px 27.5px;
          border-radius: 15px;
          box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
          border: solid 4px $color-primary;
          background-color: #f7f7f7;
          transition-duration: 0.2s;
          width: 170px;

          &.unselected {
            border: solid 4px rgba(134, 131, 131, 0.4);
            background-color: #e4e4e4;
          }

          &.selected {
            background-color: #786ade;
            border: solid 4px #786ade;
          }
        }

        .scenario-message-edit-card {
          border-radius: 6px;
          box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
          background-color: #fff;

          .sms-examples {
            cursor: pointer;
            padding: 10px 40.5px 8px 15.5px;
            border-radius: 12.5px;
            background-color: #e8e8e8;

            &.picked {
              background-color: #e4e2f8;
            }
          }
        }

        .scenario-title-edit-card {
          padding: 24px 16px 26px 15.5px;
          border-radius: 6px;
          box-shadow: 1.9px 2.9px 5px 0 rgba(51, 51, 51, 0.14);
          background-color: #fff;
        }
      }
    }
  }
}

#emoji-picker {
  background-color: white;
  max-width: 200px;
  .emoji-item {
    font-size: 18px;
    color: black !important;
  }
}

.models-toggle {
  color: white !important;

  i {
    transition-duration: 0.2s;
  }

  &[aria-expanded="true"] {
    i {
      transform: rotate(180deg);
    }
  }
}

.ProseMirror {
  padding: 6px;
  min-height: 200px;
  border: solid grey 0.1px;
  border-radius: 6px;
  h1 {
    color: black;
  }
}

.hasPicked {
  margin-bottom: 10px;
}

.email-preview-background {
  background-color: #6b5cd7;
}

.emailMessage {
  background-color: white;
}

.emailMentions {
  background-color: #6b5cd7;
}

.v-input__append-inner {
  margin-top: 14px !important;
}

.no-padding {
  margin-top: 1px !important;
  padding-top: 0px !important;
}

.email-modify {
  border: solid #6b5cd7;
  color: #6b5cd7;
}

.warning-title {
  font-size: 21px;
  color: #6f52eb;
}

.warning-bold {
  color: green;
  font-weight: bold;
}

.warning-icon {
  color: #6f52eb !important;
}

.max-char {
  color: #fe675e !important;
}

.v-tooltip__content {
  background-color: #6f52eb !important;
}

.mentions {
  font-size: 12px;
}
</style>